// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3HcGu","label":"Labeled_label__14TTs","divider":"Labeled_divider__XBN39"};